import { render, staticRenderFns } from "./TheNewUserForm.vue?vue&type=template&id=06c84442"
import script from "./TheNewUserForm.vue?vue&type=script&lang=js"
export * from "./TheNewUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports